var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'is-mobile': _vm.window.is.mobile, 'is-tablet': _vm.window.is.tablet, 'is-narrow': _vm.window.is.desktop && _vm.window.width < 1400}},[(_vm.is.ready)?_c('router-view',{key:_vm.$keyPath}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }